module.exports = __webpack_public_path__ + "img/port_centrion_previna.dffb9181.png";